import { render } from "./ViewsHomeTypeCategories.vue?vue&type=template&id=a443282a"
import script from "./ViewsHomeTypeCategories.vue?vue&type=script&lang=js"
export * from "./ViewsHomeTypeCategories.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__